import { Skeleton } from '@/components/ui/skeleton';
import { PendingRegion } from '@/shared/components/PendingRegion';

/**
 * What sits in the shell's outlet while a workspace loads (spec 079, research D2).
 *
 * Lives with the shell rather than with any one destination, because at this moment the
 * application does not yet know which destination it is going to: the route has resolved
 * but its data has not, and every child page is still possible. A shape borrowed from one
 * of them would be a guess that is wrong most of the time.
 *
 * So this is deliberately the least specific placeholder in the feature — a heading and a
 * body region — and it is the one place where that is the honest answer rather than a
 * failure to look at the content.
 */
export function WorkspacePendingBody() {
  return (
    <PendingRegion
      label="Loading workspace"
      className="gap-4 p-6 max-md:px-4 max-md:pt-4"
    >
      <Skeleton className="h-6 w-48" />
      <Skeleton className="min-h-0 flex-1" />
    </PendingRegion>
  );
}
